import { render, staticRenderFns } from "./ReadAloud.vue?vue&type=template&id=1b1315e4&"
import script from "./ReadAloud.vue?vue&type=script&lang=js&"
export * from "./ReadAloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports